import { createSlice } from "@reduxjs/toolkit";
import { sent_mails } from "../../../../types/mail/email";

export const outboxes = createSlice({
  name: "outboxes",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: sent_mails;
      }[],
      data: [] as sent_mails,
    },
  },
  reducers: {
    update_outboxes: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_outbox: (state, action) => {
      state.value.data = [action?.payload, ...state.value.data];
    },
    remove_outbox: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    replace_outbox: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_outboxes: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_outboxes,
  add_outbox,
  addToPaginationHistory,
  remove_outbox,
  replace_outbox,
  clear_outboxes,
} = outboxes.actions;

export default outboxes.reducer;
